import { db } from "../../firebase.config";
import { useState, useEffect } from "react";
import { collection, onSnapshot, addDoc, deleteDoc, doc } from "firebase/firestore";
import "./Quirks.scss";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import DetailsPanel from "../DetailsPanel/DetailsPanel";
import PopupForm from "../PopupForm/PopupForm";

const CLIENT_OPTIONS = ["Belmond", "Monsoon", "Accessorise", "Ocado", "Team Sport", "Liverpool", "Finisterre", "Tfg", "Laithwaites", "Edyn"];

function Quirks() {
  const [quirks, setQuirks] = useState([]);
  const [form, setForm] = useState({ client: "", quirk: "", desc: "" });
  const [popupActive, setPopupActive] = useState(false);
  const [selectedClient, setSelectedClient] = useState("");
  const [selectedQuirk, setSelectedQuirk] = useState(null);

  const quirksCollectionRef = collection(db, "quirks");

  useEffect(() => {
    const unsubscribe = onSnapshot(quirksCollectionRef, (snapshot) => {
      const sortedQuirks = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })).sort((a, b) => a.client.localeCompare(b.client));

      setQuirks(sortedQuirks);
    });

    return () => unsubscribe();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.client || !form.quirk || !form.desc) {
      alert("Please fill out all the fields");
      return;
    }
    addDoc(quirksCollectionRef, form);
    setForm({ client: "", quirk: "", desc: "" });
    setPopupActive(false);
  };

  const removeQuirk = (id) => {
    if (window.confirm("Are you sure you want to delete?")) {
      deleteDoc(doc(db, "quirks", id));
      if (selectedQuirk?.id === id) setSelectedQuirk(null);
    }
  };

  const filteredQuirks = selectedClient ? quirks.filter((quirk) => quirk.client.toLowerCase() === selectedClient) : quirks;

  return (
    <>
      <Header />
      <div className="App">
        <div className="hidden modalBackdrop"></div>
        <div className="functions-wrapper">
          {/* Sidebar */}
          <Sidebar>
            <div className="toolbar">
              <button onClick={() => setPopupActive(true)}>Add Quirk</button>
            </div>
            <select
              value={selectedClient}
              onChange={(e) => {
                setSelectedClient(e.target.value.toLowerCase());
                setSelectedQuirk(null);
              }}
            >
              <option value="">All Clients</option>
              {CLIENT_OPTIONS.map((client) => (
                <option key={client} value={client.toLowerCase()}>
                  {client}
                </option>
              ))}
            </select>

            {filteredQuirks.map((quirk) => (
              <div key={quirk.id} className={`snippet-preview ${selectedQuirk?.id === quirk.id ? "active" : ""}`} onClick={() => setSelectedQuirk(quirk)}>
                {quirk.client.toLowerCase()} - {quirk.quirk.toLowerCase()}
              </div>
            ))}
          </Sidebar>

          {/* Main content */}
          <DetailsPanel data={selectedQuirk} type="quirk" onRemove={removeQuirk} />
        </div>

        {/* Popup */}
        {popupActive && (
          <PopupForm
            title="Add a Quirk"
            form={form}
            onChange={(name, value) => setForm((prev) => ({ ...prev, [name]: value }))}
            onSubmit={handleSubmit}
            onClose={() => setPopupActive(false)}
            fields={[
              { label: "Client", name: "client", type: "text" },
              { label: "Quirk", name: "quirk", type: "textarea" },
              { label: "Description", name: "desc", type: "textarea" },
            ]}
          />
        )}
      </div>
    </>
  );
}

export default Quirks;
